(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaDetailController', Fee_agenziaDetailController);

    Fee_agenziaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fee_agenzia', 'Fee', 'Agenzia'];

    function Fee_agenziaDetailController($scope, $rootScope, $stateParams, previousState, entity, Fee_agenzia, Fee, Agenzia) {
        var vm = this;

        vm.fee_agenzia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:fee_agenziaUpdate', function(event, result) {
            vm.fee_agenzia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
